import { router } from "./router"
import saga from "./saga"

const middlewares = [
  router,
  saga,
  // Middlewares go here
]
export default middlewares
